<template>
  <div id="dashboard" class="content">
    <div class="block block-rounded block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">充电时长包订单</h3>
        <div class="block-options">
          <!-- <button
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
          >
            <i class="fa fa-plus mr-1"></i> 新增
          </button>-->
          <screenTime :isToday="'0'" @changePage="changePage"></screenTime>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>
      <div class="block-content block-content-full">
        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
          <div class="row mb-1">
            <div class="col-12 col-md-4 text-center text-md-left">
              <pageSize @changePageSize="changePageSize"></pageSize>
            </div>
            <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
              <div class="dt-buttons">
                <button
                  class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  tabindex="0"
                  aria-controls="DataTables_Table_1"
                  data-clipboard-text
                  @click="copy()"
                  type="button"
                  id="copybtn"
                >
                  <span>复制</span>
                </button>
                <button
                  class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  @click="exportCSV()"
                  type="button"
                >
                  <span>导出</span>
                </button>
                <button
                  class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                  @click="print()"
                >
                  <span>打印</span>
                </button>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center text-md-right">
              <div class="dataTables_filter">
                <label>
                  <input
                    type="search"
                    class="form-control"
                    placeholder="搜索"
                    v-model="key"
                    @keyup.enter="search()"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <section ref="print">
                  <table
                    class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                  >
                    <thead>
                      <tr>
                        <th
                          class="text-center sorting"
                          style="width: 60px; min-width:60px"
                          @click="getList('CREATE_TIME',$event)"
                        >#</th>
                        <th
                          class="text-left sorting"
                          style="min-width:100px;"
                          @click="getList('PACKAGE_ORDER_ID',$event)"
                        >订单号</th>
                        <th
                          class="text-left sorting"
                          style="min-width:90px;"
                          @click="getList('USER_ID',$event)"
                        >用户ID</th>
                        <th
                          class="text-left sorting"
                          style="width: 110px;min-width: 110px;"
                          @click="getList('PACKAGE_TYPE',$event)"
                        >时长包类型</th>
                        <th
                          class="text-left sorting"
                          style="min-width:100px;"
                          @click="getList('CELL_NAME',$event)"
                        >适用范围</th>
                        <!-- <th
                          class="text-left sorting"
                          style="min-width:65px;"
                          @click="getList('DESCRIPTION',$event)"
                        >包名</th>-->
                        <th
                          class="text-left sorting"
                          style="min-width:105px;"
                          @click="getList('DURATION',$event)"
                        >时长(小时)</th>
                        <th
                          class="text-left sorting"
                          style="min-width:105px;"
                          @click="getList('REMAIN_DAY',$event)"
                        >有效期(天)</th>
                        <th
                          class="text-left sorting"
                          style="min-width:90px;"
                          @click="getList('PAY_MONEY',$event)"
                        >价格(元)</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          style="min-width:95px;"
                          @click="getList('PAY_TYPE',$event)"
                        >支付方式</th>
                        <th
                          class="text-left sorting"
                          style="min-width:110px;"
                          @click="getList('CREATE_TIME',$event)"
                        >支付时间</th>
                        <!-- 

                        <th
                          class="text-left sorting d-xl-table-cell"
                          style="min-width:140px;"
                          @click="getList('REMAIN_HOUR ',$event)"
                        >剩余时长(时:分)</th>-->

                        <!-- <th
                          class="text-left sorting d-md-table-cell"
                          style="min-width:120px;"
                          @click="getList('MOBILE_PHONE',$event)"
                        >手机号码</th>
                      
                        <th
                          class="text-left sorting d-xl-table-cell"
                          style="min-width:175px;"
                          @click="getList('START_EFFECTIVE_TIME',$event)"
                        >开始时间</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          style="min-width:175px;"
                          @click="getList('EXPIRED_TIME',$event)"
                        >到期时间</th>

                        <th
                          class="text-left sorting d-xl-table-cell"
                          style="min-width:175px;"
                          @click="getList('REMAIN_MINUTE',$event)"
                        >每日可充时长(小时)</th>-->

                        <th
                          class="text-center d-xl-table-cell no-print sorting"
                          style="width: 100px; min-width:100px"
                          @click="getList('PAY_STATE',$event)"
                        >支付状态</th>
                        <th
                          class="text-center d-xl-table-cell no-print"
                          style="width: 100px; min-width:100px"
                          v-if="refundBtn"
                        >操作</th>
                      </tr>
                    </thead>
                    <tbody v-if="userPackages.length">
                      <tr v-for="(item, i) in userPackages" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>

                        <td class="text-left">
                          <div class="text-over" style="width:90px">{{ item.PACKAGE_ORDER_ID }}</div>
                          <!-- <a
                            href="javascrpit:void(0)"
                            data-toggle="modal"
                            @click="create('',item)"
                          >{{ item.PACKAGE_ORDER_ID }}</a>-->
                        </td>
                        <td class="text-left d-md-table-cell">
                          <div class="text-over" style="width:80px">{{ item.USER_ID }}</div>
                        </td>
                        <td class="text-left">{{ item.PACKAGE_TYPE}}</td>
                        <td class="text-left d-md-table-cell">{{ item.CELL_NAME }}</td>
                        <!-- <td class="text-left d-md-table-cell">{{ item.DESCRIPTION }}</td> -->
                        <td class="text-left d-md-table-cell">{{ item.DURATION }}</td>
                        <td class="text-left d-md-table-cell">{{ item.REMAIN_DAY }}</td>
                        <td class="text-left d-md-table-cell">{{ changeTwoDecimal(item.PAY_MONEY) }}</td>
                        <td class="text-left d-md-table-cell">{{ showPayType(item.PAY_TYPE) }}</td>
                        <td class="text-left d-md-table-cell">{{ item.CREATE_TIME }}</td>
                        <!-- <td class="text-left d-md-table-cell">{{ item.CELL_NAME }}</td>

                        <td class="text-left d-md-table-cell">{{ item.REMAIN_HOUR }}</td>-->

                        <!-- <td class="text-left d-md-table-cell">{{ item.MOBILE_PHONE }}</td>
                        <td class="text-left">{{ item.PACKAGE_TYPE }}</td>

                        <td class="text-left d-xl-table-cell">{{ item.START_EFFECTIVE_TIME}}</td>
                        <td class="text-left d-xl-table-cell">{{ item.EXPIRED_TIME}}</td>

                        <td
                          class="text-left d-xl-table-cell"
                          style="min-width:90px;"
                        >{{item.LIMIT_DURATION=="0"?"无限制":item.LIMIT_DURATION}}</td>

                        <td
                          class="text-left d-xl-table-cell"
                          style="min-width:80px;"
                        >{{ item.REMAIN_MINUTE }}</td>-->
                        <td class="text-center d-xl-table-cell no-print" style="min-width:80px;">
                          <span
                            class="badge badge-pill"
                            :class="{'badge-success':item.PAY_STATE=='1'||!item.PAY_STATE,'badge-secondary':item.PAY_STATE!='1'&&item.PAY_STATE}"
                          >{{item.PAY_STATE=='1'||!item.PAY_STATE?'成功':'失败'}}</span>
                        </td>
                        <td class="text-center d-xl-table-cell no-print" v-if="refundBtn">
                          <div class="btn-group">
                            <!-- <button
                              v-if="editBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              title
                              data-original-title="Edit"
                              data-toggle="modal"
                              @click="create('editAdd',item)"
                            >
                              <i class="fa fa-pencil-alt"></i>
                            </button>-->
                            <button
                              v-if="refundBtn"
                              data-toggle="modal"
                              @click="create('edit',item)"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              title="申请退款"
                              data-original-title="Edit"
                            >
                              <i class="fa fa-tasks"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="12">查无数据</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
              <div class="dataTables_info" role="status" aria-live="polite">
                页数
                <strong>{{ page }}</strong> /
                <strong>{{ totalPage }}</strong>
              </div>
            </div>
            <div class="col-sm-12 col-md-7 text-center text-md-right">
              <div class="dataTables_paginate paging_full_numbers">
                <el-pagination
                  v-if="userPackages && userPackages.length"
                  @current-change="handleCurrentChange"
                  :current-page="page"
                  :page-size="pageSize"
                  :small="isMobile"
                  :pager-count="pagerCount"
                  :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                  :total="total"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-default-normal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{edit=="edit"?"办理订单退款":"时长包信息"}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">订单号</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    disabled
                    :value="content.PACKAGE_ORDER_ID"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">用户ID</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.userId"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">时长包名</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    disabled
                    :value="content.DESCRIPTION"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">适用范围</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    disabled
                    :value="content.CELL_NAME"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">购买价格(元)</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    disabled
                    :value="changeTwoDecimal(content.PAY_MONEY)"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">购买时长</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    disabled
                    :value="content.DURATION"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">剩余时长</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    disabled
                    :value="content.REMAIN_HOUR"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">支付方式</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    disabled
                    :value="content.PAY_TYPE=='1'?'钱包余额':''"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit!='edit'">
                <label class="col-sm-12 control-label">手机号码</label>
                <div class="col-sm-12">
                  <input class="form-control" placeholder maxlength="11" v-model="phone" disabled />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit!='edit'">
                <label class="col-sm-12 control-label">时长包类型</label>
                <div class="col-sm-12">
                  <select
                    disabled
                    class="form-control"
                    id="cell-auth-type"
                    name="cell-auth-type"
                    v-model="packageType"
                  >
                    <option selected="selected" disabled="disabled">请选择</option>
                    <option
                      v-for="(item,index) in packageTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit!='edit'">
                <label class="col-sm-12 control-label">购买价格(元)</label>
                <div class="col-sm-12">
                  <input
                    disabled
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="payMoney"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit!='edit'">
                <label class="col-sm-12 control-label">开始时间</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white-ab"
                    name="example-flatpickr-default"
                    v-model="startEffectiveTime"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit!='edit'">
                <label class="col-sm-12 control-label">
                  到期时间
                  <span class="input-required" v-show="edit!=''">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white-ab"
                    name="example-flatpickr-default"
                    v-model="form.expiredTime"
                    :disabled="edit!='editAdd'"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit!='edit'">
                <label class="col-sm-12 control-label">
                  每日限制时长(小时)
                  <span class="input-required" v-show="edit!=''">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.limitDuration"
                    :disabled="edit!='editAdd'"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit!='edit'">
                <label class="col-sm-12 control-label">
                  可用时长(分钟)
                  <span class="input-required" v-show="edit!=''">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.remainMinute"
                    :disabled="edit!='editAdd'"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">
                  退款方式
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="cell-type"
                    name="cell-type"
                    v-model="form.refundType"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in refundTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='edit'">
                <label class="col-sm-12 control-label">
                  退款金额(元)
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    :disabled="form.handleType=='2'"
                    v-model="form.refundMoney"
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              v-if="edit!=''"
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit()"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../../Util.js";
import screenTime from "../../../../components/screenTime";
import pageSize from "../../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      userPackages: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      created: false,
      form: {
        packageOrderId: "",
        remark: "",
        remain: "",
        limitDuration: "",
        remainMinute: "",
        expiredTime: "",
        packageOrderId: "",
        handleType: "",
        refundType: "",
        refundMoney: "",
        refundTime: "",
        packageOrderId: "",
        userId: "",
        cellId: ""
      },
      phone: "",
      startEffectiveTime: "",
      usedState: "",
      packageType: "",
      payMoney: "",
      clipboard: null,
      edit: "",
      packageTypeList: [
        {
          value: 1,
          label: "普通"
        },
        {
          value: 2,
          label: "月底失效(清零)"
        }
      ],
      agentType: [
        {
          value: 0,
          label: "失效"
        },
        {
          value: 1,
          label: "生效"
        }
      ],
      typeList: [
        {
          value: "1",
          label: "退款"
        }
        // {
        //   value: "2",
        //   label: "退时长"
        // }
      ],
      refundTypeList: [
        {
          value: 2,
          label: "原支付返还"
        },
        {
          value: 1,
          label: "退还余额"
        }
      ],
      sorting: "",
      orderBy: false,
      content: "",
      editBtn: Util.isHavePerm("timeLen/updateChargeUserPackage"),
      refundBtn: Util.isHavePerm("userRefund/packageOrderRefund")
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    },
    "form.refundMoney"(val, oldVal) {
      this.form.refundMoney = Util.testNumberFn(val, "inputChangeTwoDecimal");
    }
  },
  mounted() {
    setTimeout(() => {
      Dashmix.helpers(["flatpickr", "datepicker"]);
    }, 1000);
    // this.getEntry()
    this.getList();
    this.copy();
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    showPayType(val) {
      switch (val) {
        case "0":
          return "钱包余额";
        case "1":
          return "微信";
        case "2":
          return "支付宝";
        case "3":
          return "其它";
      }
    },
    changePage(val) {
      this.page = val;
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    submit() {
      let url = "";
      if (this.edit == "edit") {
        url = `${Util.operateURL}/userRefund/packageOrderRefund`;
      } else {
        url = `${Util.operateURL}/timeLen/updateChargeUserPackage`;
      }

      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            jQuery("#modal-default-normal").modal("hide");
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    create(val, id) {
      this.content = id;
      jQuery("#modal-default-normal").modal("show");
      this.edit = val;
      this.message = "";
      this.form = {
        packageOrderId: id.PACKAGE_ORDER_ID,
        userId: id.USER_ID,
        packageOrderId: id.PACKAGE_ORDER_ID,
        refundMoney: "",
        remark: id.REMARK,
        remain: "",
        remainMinute: id.REMAIN_MINUTE,
        limitDuration: id.LIMIT_DURATION,
        expiredTime: Util.formatTimeToDate(id.EXPIRED_TIME),
        handleType: "",
        refundType: "",
        refundMoney: "",
        refundTime: "",
        cellId: id.CELL_ID
      };
      this.startEffectiveTime = Util.formatTimeToDate(id.START_EFFECTIVE_TIME);
      this.phone = id.MOBILE_PHONE;
      this.usedState = id.USED_STATE;
      this.packageType = id.PACKAGE_TYPE_INT;
      this.payMoney = Util.changeTwoDecimal(id.PAY_MONEY);
    },

    selectVal(ele) {
      this.selected = ele.target.value;
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/UserDurationListBy/${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,

          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Carport/UserDurationListBy/${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.userPackages = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    formatTimeToDate(val) {
      return Util.formatTimeToDate(val);
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>